import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Loading } from '@salesperformanceint/e4shared';
import TaskIcon from 'views/user/task/components/taskIcon';
import { e4Format, e4Formats, isPast } from 'helpers/dates';

export const ObjectivesModal = ({ data, st }) => {
    if (!data) return <Loading />;
    return (
        <div>
            {data.map(d => {
                return (
                    <div key={d.id} className="flex flex-top mb10">
                        <i className="fa fa-calendar mr10 mt10 text-lg" />
                        <div className="flex-grow">
                            <div>
                                <span className="mr10">
                                    <Link to={`/objectives/${d.profile_Id}/objective/${d.id}`}>{d.name}</Link>
                                    <TaskIcon icons={d.icons} />
                                </span>
                            </div>
                            <div>
                                {st('Due')}: {e4Format(d.due)}
                            </div>
                            <div>
                                {isPast(d.due) && (
                                    <span className="mr10">
                                        <label className="label label-danger uppercase">{st('Overdue')}</label>
                                    </span>
                                )}
                                {d.poked && (
                                    <span className="mr10">
                                        <label className="label label-warning uppercase">
                                            {st('Poked')}: {e4Format(d.poked)}
                                        </label>
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default withRouter(ObjectivesModal);
